var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaniumLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Tanium_Primary-Red",
    xmlns: "http://www.w3.org/2000/svg",
    width: 523.145,
    height: 94.203,
    viewBox: "0 0 523.145 94.203",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0.004 0.013)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11274",
    "data-name": "Path 11274",
    d: "M29,40H93.66A47.1,47.1,0,1,0,47.1,94.19a47.74,47.74,0,0,0,6.58-.47v-39H29Z",
    fill: "#ec2e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11275",
    "data-name": "Path 11275",
    d: "M71.22,87.54a47.12,47.12,0,0,0,22.34-32.8H71.22Z",
    fill: "#ec2e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11276",
    "data-name": "Path 11276",
    d: "M514.9,76.1h-1.36v-.75h3.58v.75h-1.35v3.69h-.87Zm7.36.2h0L521,79.79h-.67L519,76.3h0v3.49h-.86V75.35h1.39l1.11,3,1.11-3h1.39v4.44h-.86Z",
    fill: "#ec2e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11277",
    "data-name": "Path 11277",
    d: "M111.19,26.36V39.65h22.24V79.79h15.82V39.65h22.24V26.36Z",
    fill: "#ec2e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11278",
    "data-name": "Path 11278",
    d: "M200,38.76l10.26,20.07H190Zm-10.27-12.4L161.77,79.79h17.68l4.63-9.44h32.08l4.91,9.44h17.61L210.31,26.36Z",
    fill: "#ec2e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11279",
    "data-name": "Path 11279",
    d: "M297.28,26.36V65.18h-.15L267.41,26.36H242.89V79.79h15.82V40.98h.15l29.72,38.81H313.1V26.36Z",
    fill: "#ec2e30"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4653",
    "data-name": "Rectangle 4653",
    width: 15.82,
    height: 53.43,
    transform: "translate(322.37 26.36)",
    fill: "#ec2e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11280",
    "data-name": "Path 11280",
    d: "M347.47,26.36H363.3V57.21c0,6.79,2.35,9.45,8.83,9.45h15.69c6.48,0,8.83-2.66,8.83-9.45V26.36h15.83V60.75c0,13.29-6.63,19.63-21.17,19.63H368.64c-14.54,0-21.17-6.34-21.17-19.63Z",
    fill: "#ec2e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11281",
    "data-name": "Path 11281",
    d: "M421.75,26.36h24.31l17.89,34.39,17.89-34.39h24.31V79.79h-15.4V41.42h-.14L469.87,79.79H458.03L437.29,41.42h-.14V79.79h-15.4Z",
    fill: "#ec2e30"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaniumLogo);
export default __webpack_public_path__ + "static/media/tanium_logo.740116b0e14a5ccc9cfbadc921ebb8d3.svg";
export { ForwardRef as ReactComponent };